import {
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";

import { useAdminPullRequests } from "@/admin/data/useAdminPullRequests";
import TimestampCell from "@/common/components/TimestampCell";
import {
  FormatPR,
  PullRequestStatusBadge,
} from "@/feature/components/PullRequestLink";
import { Org } from "@reflag/shared/organizationAPI";

export default function AdminOrgPullRequests({
  org,
}: {
  org: Pick<Org, "id">;
}) {
  const { data = [], isLoading } = useAdminPullRequests(org.id);

  if (isLoading) {
    return <Spinner />;
  }

  if (data.length === 0) {
    return <Text color="dimmed">No pull requests found</Text>;
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Title</Th>
          <Th>Status</Th>
          <Th>Created</Th>
          <Th>Updated</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data.map((pullRequest) => (
          <Tr key={pullRequest.id}>
            <Td>
              <RouterLink to={`/admin/${org.id}/pulls/${pullRequest.id}`}>
                <Flex align="center" gap={2} maxW="xs">
                  <FormatPR
                    number={pullRequest.number ?? undefined}
                    title={pullRequest.title}
                  />
                </Flex>
              </RouterLink>
            </Td>
            <Td>
              <PullRequestStatusBadge status={pullRequest.status} />
            </Td>

            <Td>
              <TimestampCell value={pullRequest.createdAt} />
            </Td>
            <Td>
              <TimestampCell value={pullRequest.updatedAt} />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
